import Vue from 'vue'
import Vuex from 'vuex'
import router, {resetRouter} from "@/router";
import {removeToken} from "../../public/config";
import request from "@/utils/request";


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        currentPathName: ''
    },
    mutations: {
        setPath (state) {
            state.currentPathName = localStorage.getItem("currentPathName")
        },
        logout(){
            // 调后端登出接口销毁token
            request.post("/sysuser/logout").catch(() => {})
            // 清空缓存
            localStorage.removeItem("user")
            localStorage.removeItem("menus")
            removeToken()
            router.push("/login")

            // 重置路由
            resetRouter()

        }
    }
})

export default store
